"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
// eslint-disable-next-line
exports.en_us = {
    locale: 'en_us',
    // 操作：确定按钮
    resetText: ('Reset'),
    // 暂无数据
    noData: ('No Data Found'),
};
//# sourceMappingURL=en_us.js.map